import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ObservationCard } from "~/modules/mapEditor/components/ObservationCard";
import { ObservationCardFragment } from "~/modules/mapEditor/components/ObservationCard/fragments.generated";

import LinkableItemList from "../../LinkableItemList";

interface LinkedObservationsListProps {
    createHrefToObservation: (element: ObservationCardFragment) => string;
    observations: ObservationCardFragment[];
    onUnlinkClick: (observationId: string) => Promise<void>;
}

export function LinkedObservationsList({ createHrefToObservation, observations, onUnlinkClick }: LinkedObservationsListProps) {
    const { t } = useTranslation("mapEditor");

    return (
        <>
            <Divider>{t("observationLinking.dividerLinkedObservations")}</Divider>
            <LinkableItemList
                clickable
                createTo={createHrefToObservation}
                items={observations}
                renderCard={element => <ObservationCard observation={element} onUnlinkClick={onUnlinkClick} isLinked={true} />}
            />
        </>
    );
}
